import { ReactElement } from 'react';
import { styled } from '@mui/material';

import { PoolTypography, PoolTypographyProps } from '../pool-typography/pool-typography';

interface StyledTypographyProps {
    maxLines: number;
}

const StyledTypography = styled(PoolTypography, {
    shouldForwardProp: prop => prop !== 'maxLines',
})<StyledTypographyProps>(({ maxLines }) => ({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flex: 'unset',
    WebkitLineClamp: maxLines.toString(),
    wordBreak: maxLines > 1 ? 'break-word' : 'break-all',
    whiteSpace: 'pre-wrap',
}));

type PoolLineClampTypographyProps = PoolTypographyProps & { maxLines?: number };

export const PoolLineClampTypography = (props: PoolLineClampTypographyProps): ReactElement => {
    const { maxLines = 1, ...baseProps } = props;
    return <StyledTypography maxLines={maxLines} {...baseProps} />;
};
